import { render, staticRenderFns } from "./BottomPanel.vue?vue&type=template&id=2cd5af12&"
import script from "./BottomPanel.vue?vue&type=script&lang=js&"
export * from "./BottomPanel.vue?vue&type=script&lang=js&"
import style0 from "./BottomPanel.vue?vue&type=style&index=0&id=2cd5af12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports